<template>
  <section>
    <Feed
      v-model:sort="blog.state.sort"
      :ssr="true"
      :showLoadMore="false"
      :states="{
        empty: {
          title: $t('community.blog.empty.title'),
          description: $t('community.blog.empty.description')
        },
      }"
      :store="{
        read: (options) => blog.read(options)
      }"
      :options="{
        limit: 15,
        category: route.params.category,
        period: route.query.period,
        tags: route.query.tags,
        status: 'published',
        user: auth.state.user._id,
        following: route.params.category === 'following' ? auth.state.user._id : null,
      }"
      v-slot="{ 
        items 
      }"
      class="rows-1 gap-thin"
    >
      <CardBlogpost
        v-for="item in items"
        :key="item._id"
        :blogpost="item"
        :user="auth.state.user._id"
        class="card card--flush mobile:radius-zero"
      />
    </Feed>
  </section>
</template>


<script setup="props">
  import { ref, computed, onMounted, onBeforeUnmount, nextTick, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useHead } from '@unhead/vue';

  import Breadcrumbs from '@martyrs/src/design-system/components/Breadcrumbs/Breadcrumbs.vue';
  import Feed from '@martyrs/src/design-system/components/Feed/Feed.vue'

  import CardBlogpost from '@martyrs/src/modules/community/components/blocks/CardBlogpost.vue';

  // Import state
  import * as blog from '@martyrs/src/modules/community/store/blogposts.js';
  import * as auth  from '@martyrs/src/modules/auth/views/store/auth.js'

  // State
  const route = useRoute();
  const router = useRouter();

  useHead({
    title: 'Блог | OfferStream',
    meta: [
      { hid: 'description', name: 'description', content: 'Статьи о поиске работы на hh.ru: автоотклики, сопроводительные письма, собеседования и советы по трудоустройству.' }
    ]
  });

  // if (!route.params.category) {
  //   route.params.category = 'popular'
  // }
 
  onMounted(() => {

    if (route.query) {
      const query = route.query;

      const newFilterValue = {
        tags: query.tags ? query.tags.split(',') : [],
        period: query.period ? query.period : null,
      };

      // проверяем наличие категории в route.params и добавляем ее в фильтр
      // if (route.params.category) {
      //   newFilterValue.category = route.params.category;
      // }

      blog.state.filter = newFilterValue;
    }
    
  });

  // Запоминаем позицию скролла ленты, чтобы при возврате со статьи оказаться на ней.
  // Скроллится контейнер #scrollview (не window). Лента грузится async — восстанавливаем
  // с rAF-ретраем, пока высота не дорастёт (layout сбрасывает scrollTop в 0 при входе).
  const SCROLL_KEY = 'community-scroll-top';
  const getScroller = () => (typeof document !== 'undefined' ? document.getElementById('scrollview') : null);

  onBeforeUnmount(() => {
    const s = getScroller();
    if (s) sessionStorage.setItem(SCROLL_KEY, String(s.scrollTop));
  });

  onMounted(() => {
    const saved = parseInt(sessionStorage.getItem(SCROLL_KEY) || '0', 10);
    if (!saved) return;
    const s = getScroller();
    if (!s) return;
    const deadline = Date.now() + 2000;
    const restore = () => {
      s.scrollTop = saved;
      if (Math.abs(s.scrollTop - saved) > 2 && Date.now() < deadline) requestAnimationFrame(restore);
    };
    nextTick(() => requestAnimationFrame(restore));
  });

  watch(() => blog.state.filter, (newFilterValue, oldFilterValue) => {
    // Переводим фильтр в формат query
    const query = { ...route.query };

    // Удаляем старые значения фильтра из query
    Object.keys(oldFilterValue).forEach(key => {
      if (query[key]) {
        delete query[key];
      }
    });

    // Добавляем новые значения фильтра в query
    const newQueryValues = Object.fromEntries(
      Object.entries(newFilterValue)
        .filter(([key, value]) => (Array.isArray(value) && value.length > 0) || (typeof value === 'string' && value))
        .map(([key, value]) => [key, Array.isArray(value) ? value.join(',') : value])
    );
    Object.assign(query, newQueryValues);

    // Обновляем маршрут с новым query
    router.replace({ query });
  }, { deep: true })
</script>

<style lang="scss">

</style>
